import React, { useState } from 'react';
import { AiOutlineHome, AiOutlineUser } from 'react-icons/ai';
import { BiBook, BiMessageSquareDetail } from 'react-icons/bi';
import { RiServiceLine } from 'react-icons/ri';

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#home');

  return (
    <nav className="fixed left-1/2 transform -translate-x-1/2 bottom-8 z-10 flex bg-transparent border border-primary p-4 rounded-full backdrop-blur-sm">
      <a
        href="#home"
        onClick={() => setActiveNav('#home')}
        className={`link-common ${activeNav === '#home' ? 'link-active' : 'link-inactive'}`}
      >
        <AiOutlineHome />
      </a>
      <a
        href="#about"
        onClick={() => setActiveNav('#about')}
        className={`link-common ${activeNav === '#about' ? 'link-active' : 'link-inactive'}`}
      >
        <AiOutlineUser />
      </a>
      <a
        href="#experience"
        onClick={() => setActiveNav('#experience')}
        className={`link-common ${activeNav === '#experience' ? 'link-active' : 'link-inactive'}`}
      >
        <BiBook />
      </a>
      <a
        href="#services"
        onClick={() => setActiveNav('#services')}
        className={`link-common ${activeNav === '#services' ? 'link-active' : 'link-inactive'}`}
      >
        <RiServiceLine />
      </a>
      <a
        href="#contact"
        onClick={() => setActiveNav('#contact')}
        className={`link-common ${activeNav === '#contact' ? 'link-active' : 'link-inactive'}`}
      >
        <BiMessageSquareDetail />
      </a>
    </nav>
  );
};

export default Nav;
